import React from 'react';
import Footer from "./Footer";
function Services() {
  const services = [
    { title: "Consulting & Strategy", description: "Expert guidance to optimize your business strategy." },
    { title: "Software Development & Integration", description: "Custom solutions tailored to your needs." },
    { title: "System Design & Architecture", description: "Robust and scalable systems designed for your business." },
    { title: "IT Support & Maintenance", description: "24/7 support to keep your systems running smoothly." },
  ];

  return (
    <>
    <div className="services-page">
      <h1 className="services-header">Our Services</h1>
      
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
    <Footer />
    </>
  );
}

export default Services;
